export { EUpdateProvider } from './EUpdateProvider';
export { IUpdate } from './IUpdate';
export { IUpdateConfig } from './IUpdateConfig';
export { IUpdatePlatformConfig } from './IUpdatePlatformConfig';
export { IUpdateResult } from './IUpdateResult';
